import { each } from 'lodash';
import { runBasePreload } from '../../../common/logic/generalPreload';

const runPreload = (data, withImages, concepts, dispatchChangeLoadingState) => {
  runBasePreload(data, dispatchChangeLoadingState, (baseSrcList) => {
    if (!!concepts && !!concepts.length && !!withImages) {
      each(concepts, (concept) => {
        baseSrcList.push({
          src: concept.url,
          callback: (img) => { concept.object = img; }
        });
      });
    }
  });
};

export default runPreload;
